import React from 'react';
import '../styles/Header.css';

interface HeaderProps {
  userName?: string;
  onMenuClick: () => void;
  onAddClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ userName, onMenuClick, onAddClick }) => {
  return (
    <header className="app-header">
      <button className="menu-button" onClick={onMenuClick}>
        <span className="hamburger-icon">☰</span>
      </button>
      
      <h1 className="app-title">
        <img src="/icon-192x192.png" alt="hibi" className="app-logo" />
        <span>hibi</span>
      </h1>
      
      <div className="header-right">
        <button className="add-button" onClick={onAddClick}>
          <span className="add-icon">＋</span>
        </button>
      </div>
    </header>
  );
};

export default Header;